import React from 'react';
import { Link } from 'react-router-dom';
import { shopTrueEmptySotHref } from './createShopJob';
import { SHOP_JOBS_SOT_VALUES, shopJobsSotExitHref, shopJobsSotHref } from './jobsSurface';

const SOT_LABELS = {
    empty: 'EMPTY',
    error: 'ERROR',
    offline: 'OFFLINE',
    pending: 'PENDING · EMPTY',
    'pending-handoff': 'PENDING · HANDOFF',
    handoff: 'HANDOFF · ACTIVE',
    'complete-handoff': 'COMPLETE · HANDOFF',
};

const JobsSotSwitcher = ({ active, search = '' }) => (
    <nav
        className="jobs-sot-switcher"
        data-testid="jobs-sot-switcher"
        aria-label="Shop jobs SoT"
    >
        {SHOP_JOBS_SOT_VALUES.map((surface) => (
            <Link
                key={surface}
                className={`jobs-sot-link${active === surface ? ' is-active' : ''}`}
                to={shopJobsSotHref(surface, search)}
            >
                {SOT_LABELS[surface]}
            </Link>
        ))}
        <Link className="jobs-sot-link" to={shopTrueEmptySotHref('walk')}>
            TRUE EMPTY · WALK
        </Link>
        <Link className="jobs-sot-link" to={shopJobsSotExitHref()}>
            Exit SoT
        </Link>
    </nav>
);

export default JobsSotSwitcher;
